import { defineStore } from 'pinia';

import { usePermissionStore } from '@/store';
import type { UserInfo } from '@/types/interface';
import { request } from '@/utils/request';

const InitUserInfo: UserInfo = {
  name: '', // 用户名，用于展示在页面右上角头像处
  roles: [], // 前端权限模型使用 如果使用请配置modules/permission-fe.ts使用
  permissions: [],
  adminPortalUser: false,
};

export const useUserStore = defineStore('user', {
  state: () => ({
    token: '', // 默认空，需要登录获取
    username: '', // 登录账号，用于发请求时带 username header
    usertype: '', // 用户类型，用于发请求时带 usertype header
    permissions: [] as string[],
    adminPortalUser: false,
    userInfo: { ...InitUserInfo },
  }),
  getters: {
    roles: (state) => {
      return state.userInfo?.roles;
    },
  },
  actions: {
    async login(userInfo: Record<string, unknown>) {
      const res = await request.post<any>(
        {
          url: '/user/admin/login',
          data: {
            username: userInfo.account as string,
            password: userInfo.password as string,
          },
        },
        {
          isTransformResponse: false,
        },
      );

      if (res.message === 'SUCCESS') {
        this.token = res.data.authorization;
        this.username = res.data.username || '';
        this.usertype = res.data.usertype || '';
        this.permissions = res.data.permissions || [];
        this.adminPortalUser = !!res.data.adminPortalUser;
        this.userInfo = {
          name: this.username || '管理员',
          roles: res.data.roles || [],
          permissions: this.permissions,
          adminPortalUser: this.adminPortalUser,
        };
      } else {
        throw new Error(res.message || '登录失败');
      }
    },
    async getUserInfo() {
      this.userInfo = {
        name: this.username || '管理员',
        roles: this.userInfo?.roles?.length ? this.userInfo.roles : [],
        permissions: this.permissions || [],
        adminPortalUser: this.adminPortalUser,
      };
    },
    async logout() {
      this.token = '';
      this.username = '';
      this.usertype = '';
      this.permissions = [];
      this.adminPortalUser = false;
      this.userInfo = { ...InitUserInfo };
    },
  },
  persist: {
    afterRestore: () => {
      const permissionStore = usePermissionStore();
      permissionStore.initRoutes();
    },
    key: 'user',
    paths: ['token', 'username', 'usertype', 'userInfo', 'permissions', 'adminPortalUser'],
  },
});
